import { useCallback } from "react";
import { useWebHaptics } from "web-haptics/react";
import type { VideoCategory } from "../content";
import { HAPTIC_LIGHT_NAV } from "../hapticPatterns";

type Props = {
  categories: readonly VideoCategory[];
  onClose: () => void;
  onOpenCategory: (category: VideoCategory) => void;
};

export function GalleryScreen({ categories, onClose, onOpenCategory }: Props) {
  const { trigger } = useWebHaptics();
  const tap = useCallback(() => void trigger([...HAPTIC_LIGHT_NAV]), [trigger]);

  const handleClose = useCallback(() => {
    tap();
    onClose();
  }, [tap, onClose]);

  const openHighlight = useCallback(
    (cat: VideoCategory) => {
      tap();
      onOpenCategory(cat);
    },
    [tap, onOpenCategory],
  );

  return (
    <div className="app-screen">
      <header className="app-header">
        <button type="button" className="app-back" onClick={handleClose}>
          ← Home
        </button>
        <div className="app-header-brand">
          <h1 className="app-title">Gallery</h1>
        </div>
      </header>
      <div className="app-body gallery-body">
        <p className="gallery-hint">Previous Work</p>
        <ul className="highlight-list">
          {categories.map(cat => (
            <li key={cat.id}>
              <button type="button" className="highlight-row" onClick={() => openHighlight(cat)}>
                <span className="highlight-ring" aria-hidden style={{ backgroundImage: `url(${cat.image})` }} />
                <span className="highlight-title">{cat.title}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
